module.exports = __webpack_public_path__ + "media/images/new-24-green-86bd66d5c7624b8097a619e8004838bb.png";